import React from 'react'
import styled from 'styled-components'
import { media, rem } from '../../utils'
import Img from 'gatsby-image'
import { APP_URL } from '../../utils'
import CtaBtn from '../common/CtaBtn'

const Meet = props => {
  // console.log('props', props)
  const { meetBackground, meetImage, meetSubtitle, meetTitle } = props

  return (
    <MeetWrap>
      <BackgroundWrap>
        <Img className="meetBackground" fluid={meetBackground.fluid} />
      </BackgroundWrap>
      <Content>
        <h2 className="meetTitle">{meetTitle}</h2>
        <h5 className="meetSubtitle">{meetSubtitle}</h5>
        <CtaBtn background style={{ marginTop: 30 }} href={APP_URL}>
          Get Started
        </CtaBtn>
        <ImageWrap href={APP_URL} target="_blank">
          <a href={APP_URL}>
            <Img fadeIn={false} className="phone" fluid={meetImage.fluid} />
          </a>
        </ImageWrap>
      </Content>
    </MeetWrap>
  )
}

const MeetWrap = styled.div`
  position: relative;
  .meetBackground {
    height: 100%;
  }
`

const BackgroundWrap = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

const Content = styled.div`
  position: relative;
  z-index: 1;
  padding: ${rem(75)} ${rem(30)};
  padding-bottom: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  h2 {
    ${media.tablet`
      font-size: ${rem(40)};
      `};
  }

  h5 {
    margin-top: ${rem(10)};
    max-width: ${rem(500)};
    ${media.tablet`
      font-size: ${rem(18)};
      `};
  }
`

const ImageWrap = styled.div`
  width: 100%;
  margin-top: ${rem(50)};
  a {
    display: block;
    max-width: ${rem(400)};
    margin: 0 auto;
  }
  .phone {
    /* margin: 0 auto;
    max-width: 400px; */
  }
`

export default Meet
